import { getJobListFromRepository } from 'application/repositories/joblistRepository';

export const getJobList = async (params: Models.JobList): Promise<Models.Job> => {
	return await getJobListFromRepository(params);
};
